export const HOME = { emergentLink: "emergent-link" };

export const AUTH = {
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerForm: "register-form",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  logoutButton: "logout-button",
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  statsCard: "admin-stats-card",
  customersTable: "admin-customers-table",
  customerRow: "admin-customer-row",
  suspendButton: "admin-suspend-customer-button",
  activateButton: "admin-activate-customer-button",
  creditButton: "admin-add-credits-button",
  providersPanel: "admin-providers-panel",
  approvePaymentButton: "admin-approve-payment-button",
  rejectPaymentButton: "admin-reject-payment-button",
  approveSenderIdButton: "admin-approve-sender-id-button",
};

export const CUSTOMER = {
  dashboard: "customer-dashboard",
  balanceCard: "customer-balance-card",
  composeButton: "customer-compose-sms-button",
  smsForm: "sms-compose-form",
  smsRecipient: "sms-recipient-input",
  smsSenderId: "sms-sender-id-select",
  smsMessage: "sms-message-textarea",
  smsSegmentInfo: "sms-segment-info",
  smsSendButton: "sms-send-button",
  contactsTable: "contacts-table",
  addContactButton: "add-contact-button",
  walletBalance: "wallet-balance-display",
  buyCreditsButton: "buy-credits-button",
  senderIdForm: "sender-id-request-form",
  apiKeysPanel: "api-keys-panel",
  createApiKeyButton: "create-api-key-button",
};
